module.exports = __webpack_public_path__ + "img/thank-you.f2f7f467.svg";